export default "__VITE_ASSET__DoKfJUsd__"